import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import { Core2Config } from '../../shared';
import {QueryRunHdrModel} from '../../../../../../models';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class QueryRunHdrService extends BaseApiTemplateService<QueryRunHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/query-run-hdrs/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-hdrs/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-hdrs/backoffice-ep';
    this.httpClient = theHttp;
  }

  createRuns(dtoObject: QueryRunHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<QueryRunHdrModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-hdrs/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-run-hdrs/processors/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<QueryRunHdrModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }

  updateRuns(dtoObject: QueryRunHdrModel, visa: ApiVisa): Observable<BasicApiResponseModel<QueryRunHdrModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-hdrs/processors/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-run-hdrs/processors/backoffice-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<QueryRunHdrModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa));
  }
}
